// src/api/countryApi.ts
import axios from './axyos'
import { Country } from '../features/country/countrySlice'

export const getCountriesApi = () => { return axios.get('/listCountries'); }

export const postCountryApi = (data: Country) => axios.post('/saveCountry', data)

export const deleteCountryApi = (idOrCode: string) => axios.delete(`/countries/${idOrCode}`)

export const putCountryApi = (idOrCode: string, data: Country) => axios.put(`/countries/${idOrCode}`, data)
